'use strict';
import {prioritiesListReducers} from './prioritiesListReducers';

export * from './state';

export const priorities = prioritiesListReducers;



// WEBPACK FOOTER //
// ./src/js/priorities/reducers/index.js